import { z } from 'zod';

const CommissionPolicyCellSchema = z.object({
  enabled: z.boolean(),
  rateBps: z.number().int().nullable(),
});

export const CommissionPolicyMatrixSchema = z.object({
  mechanicService: CommissionPolicyCellSchema,
  mechanicPart: CommissionPolicyCellSchema,
  sellerService: CommissionPolicyCellSchema,
  sellerPart: CommissionPolicyCellSchema,
});
export type CommissionPolicyMatrix = z.infer<typeof CommissionPolicyMatrixSchema>;

export const UpsertTenantCommissionPolicyBodySchema = z.object({
  locked: z.boolean(),
  matrix: CommissionPolicyMatrixSchema,
});
export type UpsertTenantCommissionPolicyBody = z.infer<
  typeof UpsertTenantCommissionPolicyBodySchema
>;

export const UpsertTenantCommissionPolicyResponseSchema = UpsertTenantCommissionPolicyBodySchema;
export type UpsertTenantCommissionPolicyResponse = UpsertTenantCommissionPolicyBody;

export const TenantCommissionPolicyItemSchema = z.object({
  id: z.uuid(),
  locked: z.boolean(),
  matrix: CommissionPolicyMatrixSchema,
});

export const ListTenantCommissionPoliciesResponseSchema = z.object({
  items: z.array(TenantCommissionPolicyItemSchema),
});
export type ListTenantCommissionPoliciesResponse = z.infer<
  typeof ListTenantCommissionPoliciesResponseSchema
>;

export const UpsertPlaceCommissionPolicyBodySchema = z.object({
  matrix: CommissionPolicyMatrixSchema,
});
export type UpsertPlaceCommissionPolicyBody = z.infer<typeof UpsertPlaceCommissionPolicyBodySchema>;

export const UpsertPlaceCommissionPolicyResponseSchema = z.object({
  placeId: z.uuid(),
  matrix: CommissionPolicyMatrixSchema,
});
export type UpsertPlaceCommissionPolicyResponse = z.infer<
  typeof UpsertPlaceCommissionPolicyResponseSchema
>;

export const PlaceCommissionPolicyItemSchema = z.object({
  id: z.uuid(),
  placeId: z.uuid(),
  matrix: CommissionPolicyMatrixSchema,
});

export const ListPlaceCommissionPoliciesResponseSchema = z.object({
  items: z.array(PlaceCommissionPolicyItemSchema),
});
export type ListPlaceCommissionPoliciesResponse = z.infer<
  typeof ListPlaceCommissionPoliciesResponseSchema
>;

export const ResolveCommissionPolicyResponseSchema = z.object({
  matrix: CommissionPolicyMatrixSchema,
  resolvedFrom: z.enum(['TENANT', 'PLACE']),
});
export type ResolveCommissionPolicyResponse = z.infer<typeof ResolveCommissionPolicyResponseSchema>;
